import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { BookingResponse } from '../../../backend/src/models/bookingDetails';
// import { Booking } from '../pages/MyBookings';
import { useAppContext } from '../contexts/AppContext';
// import { useLocation } from "react-router-dom";

// interface BookingConfirmationProps {
//   booking: BookingResponse;
//   bookingFromDB: Booking;
// }

const BookingConfirmComponent: React.FC<{ bookingFromDB: any}> = ({ bookingFromDB }) => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAppContext();

  const handleViewBookings = () => {
    navigate('/my-bookings');
  };

  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <div className="container mx-auto p-8">
      <div className="flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow-xl p-8 space-y-8">
        {/* Confirmation Icon */}
        <div
          className={`rounded-full p-4 flex items-center justify-center ${bookingFromDB.holdOrPaid === "paid" || bookingFromDB.holdOrPaid === "hold"
            ? "bg-green-100"
            : "p-0 bg-white"
            }`}
        >
          <img
            src={
              bookingFromDB.holdOrPaid === "paid" || bookingFromDB.holdOrPaid === "hold"
                ? "/featureIcons/confirmed.svg"
                : "/featureIcons/hold.svg"
            }
            alt={
              bookingFromDB.holdOrPaid === "paid" || bookingFromDB.holdOrPaid === "hold"
                ? "Success Icon"
                : "Pending Icon"
            }
            className= {bookingFromDB.holdOrPaid === "paid" || bookingFromDB.holdOrPaid === "hold"
              ? "w-14 h-14" : "w-[4.5rem] h-[4.5rem]" } 
          />
        </div>

        {/* Success/Error Message */}
        <div className="text-center">
          {bookingFromDB.holdOrPaid === "paid" || bookingFromDB.holdOrPaid === "hold" ? (
            <>
              <h2 className="text-3xl font-bold text-gray-800">
                {bookingFromDB.holdOrPaid === "paid" ? "Booking Confirmed!" : "Reservation Confirmed"}
              </h2>
              <p className="text-gray-600 mt-2">
                {bookingFromDB.holdOrPaid === "paid"
                  ? "Your booking has been successfully confirmed. You will receive a confirmation email shortly."
                  : "Your reservation has been successfully placed. Please check your email for further details."}
              </p>
            </>
          ) : (
            <>
              <h2 className="text-3xl font-bold text-[#F78037]">Booking Pending</h2>
              <p className="text-gray-600 mt-2">
                There was an issue with your booking. Our support team will contact you shortly to resolve it.
              </p>
            </>
          )}
        </div>

        {/* Booking Details */}
        <div className="w-full bg-gray-50 rounded-lg p-6 space-y-4 shadow-sm">
          <div className="flex justify-between">
            <span className="font-medium text-gray-700">Booking Reference:</span>
            <span className="text-gray-900">{bookingFromDB.reference}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-700">Paid Amount:</span>
            <span className="text-gray-900">
              {bookingFromDB.paidAmount === "" ? "-" : `£${bookingFromDB.paidAmount}`}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-700">Booking Status:</span>
            <span
              className={
                bookingFromDB.holdOrPaid === "hold"
                  ? "text-green-600 font-semibold"
                  : bookingFromDB.holdOrPaid === "paid"
                    ? "text-green-600 font-semibold"
                    : "text-[#F78037] font-semibold"
              }
            >
              {bookingFromDB.holdOrPaid === "hold"
                ? "On Hold"
                : bookingFromDB.holdOrPaid === "paid"
                  ? "Confirmed"
                  : "Pending"}
            </span>
          </div>
        </div>

        {/* Next Actions */}
        <div className="flex flex-wrap gap-4 justify-center">
          {isLoggedIn && (
            <button
              onClick={handleViewBookings}
              className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-lg hover:bg-blue-700 shadow-md"
            >
              View My Bookings
            </button>
          )}
          <button
            onClick={handleReturnHome}
            className="bg-gray-300 text-gray-800 font-semibold py-2 px-6 rounded-lg hover:bg-gray-400 shadow-md"
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmComponent;
